export default __webpack_public_path__ + "990ec546d5595a28b7d0854f09b5fdb1.ttf";